import { Pipe, PipeTransform } from '@angular/core';
import { Shift } from '@wilson/interfaces';
import { isShiftDraggable } from './is-shift-draggable.util';

@Pipe({
  name: 'isShiftDraggable',
  standalone: false,
})
export class IsShiftDraggablePipe implements PipeTransform {
  transform(shift: Shift): boolean {
    return isShiftDraggable(shift);
  }
}
